import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";
import { ModoDebugUsuario } from "app/models/modo-debug-usuario.model";
import { ModoDebugHistoricoItem } from "app/models/modo-debug-historico-item.model";
import { ModoDebugDadosPessoais } from "app/models/modo-debug-dados-pessoais.model";
import { Pageable } from "app/models/pageable-mode";

export abstract class AbModoDebug extends AppService {
  abstract listar(filter: AppFilter): Observable<Pageable<ModoDebugUsuario>>;
  abstract listarComLiberacaoAtiva(filter: AppFilter): Observable<Pageable<ModoDebugUsuario>>;
  abstract buscarPorId(usuarioId: number): Observable<ModoDebugUsuario>;
  abstract historico(usuarioId: number, filter: AppFilter): Observable<Pageable<ModoDebugHistoricoItem>>;
  abstract dadosPessoais(usuarioId: number): Observable<ModoDebugDadosPessoais>;
  abstract ativar(usuarioId: number): Observable<any>;
  abstract renovar(usuarioId: number): Observable<any>;
  abstract revogar(usuarioId: number): Observable<any>;
}
